/**
 * Created by PRIME AI.
 * @author Samuel Hinchliffe <samuel@primeai.co.uk, sam.hinchliffe.work@gmail.com>
 * @see    [Linkedin] {@link https://www.linkedin.com/in/samuel-hinchliffe-2bb5801a5/}
 *
 * @summary The AppManager manages all the apps. The job of this class
 * is to bring in the apps you want and manage them. To start an app, to end an app etc.
 *
 * This is your base app, you load the apps required for you base app here.
 *
 * Created at: 15/11/2023
 * @see       [PRIME-AI GITHUB] {@link https://github.com/PRIME-AI-GITHUB}
 * @see       [Website]         {@link https://www.primeai.co.uk/}
 * @copyright 2018-2023 PRIME AI LTD
 */

// import AppFactory from './AppFactory';
// import Analytics from './Mixins/Analytics';
// import FindClothesByPictures from './Apps/FindClothesByPictures';
// import StyleSnap from './Apps/StyleSnap';
// import Log from './Mixins/Log';

// !! Make it so that you must implement said functions.
// !! so it extends some form of an interface.
export default class PrimeAppManager {
    constructor() {
        // The App Factory lays at the heart of this entire project.
        // the Factory holds all that is important.
        this.appFactory = null;
    }

    // async init() {
    //     this.appFactory = await AppManager.autoBuild();

    //     // The baseline configuration of this retailer to be shared among all.
    //     this.config = await this.appFactory.loadConfig(`${this.appFactory.hostPath}/configuration/${this.appFactory.retailerId}__config.json`);

    //     // Allow for analytics
    //     this.analytics = new Analytics(this.config, this.appFactory.productId);
    //     this.appFactory.analytics = this.analytics;

    //     // Expose a global reference to the AppRunner of these Components.
    //     window.__PRIME_AI_FCBP__.AppManager = this;

    //     // !! CONDITION CHECK. CAN ANY APPS RUN AT ALL HERE? THE MASTER CHECK.

    //     // The recommendation app is only allowed to run if on a pdp page.
    //     this.findClothesByPictures = new FindClothesByPictures(this.config, this.appFactory, this.appFactory.productId);
    //     this.styleSnap = new StyleSnap(this.config, this.appFactory);

    //     // Do the apps depend on one another for loading? if not, don't await. if so await.
    //     // Load in all the apps.
    //     this.findClothesByPictures.init();
    //     this.styleSnap.init();

    //     // Do not continue until both apps have loaded.
    //     // await Promise.all([ctaLoaded, windowLoaded]);

    //     return true;
    // }

    // static async autoBuild() {
    //     try {
    //         // Let's attempt to get the parents retailer id from the site.
    //         // A company can have many brands. O'Neill -> [EU,US,UK] etc.
    //         const parent = AppFactory.getParentRetailerId();

    //         // If the retailers script isn't here yet, just await.
    //         const exclusiveLogic = await AppFactory.waitForVariable('__PRIME_AI_FCBP__');

    //         console.log(...Log.w('AppManager', 'LOG', 'Debugger Enabled'));
    //         console.log(...Log.w('AppManager', 'LOG', 'Retailers Logic | Loaded!'));

    //         let retailer = AppFactory.getChildRetailerId();
    //         if (exclusiveLogic.getRetailerId) {
    //             console.log(...Log.w('AppManager', 'INFO', 'Retailers Logic getRetailerId() used'));
    //             retailer = exclusiveLogic.getChildRetailerId();
    //         }
    //         let isPdpPage = AppFactory.isPdpPage();
    //         if (exclusiveLogic.isPdpPage) {
    //             console.log(...Log.w('AppManager', 'INFO', 'Retailers Logic isPdpPage() used'));
    //             isPdpPage = exclusiveLogic.isPdpPage();
    //         }

    //         let productId = await AppFactory.getProductId();
    //         if (exclusiveLogic.getProductId) {
    //             console.log(...Log.w('AppManager', 'INFO', 'Retailers Logic getProductId() used'));
    //             productId = exclusiveLogic.getProductId();
    //         }

    //         let userDevice = AppFactory.getUserDevice();
    //         if (exclusiveLogic.getUserDevice) {
    //             console.log(...Log.w('AppManager', 'INFO', 'Retailers Logic userDevice() used'));
    //             userDevice = exclusiveLogic.userDevice();
    //         }

    //         console.log(
    //             ...Log.w(
    //                 'AppManager',
    //                 'LOG',
    //                 `AppFactory Configuration: \n
    //         ParentId: ${parent}\n
    //         RetailerId: ${retailer}\n
    //         ProductId: ${productId}\n
    //         PDP-Page: ${isPdpPage}\n
    //         Device: ${userDevice}`,
    //             ),
    //         );

    //         return new AppFactory({
    //             parentId: parent,
    //             retailerId: retailer,
    //             productId,
    //             userDevice,
    //             isPdpPage,
    //             masterConfig: __PRIME_AI_FCBP__,
    //         });
    //     } catch (error) {
    //         throw new Error(`Cannot AutoBuild (End Program): ${error}`);
    //     }
    // }
}
